import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'export-button',
    templateUrl: './export-button.component.html',
})
export class ExportButtonComponent {

    @Input() elementId: string = 'exportBtn';

    @Input() hideXlsButton: boolean = false;

    @Input() disableWhen: boolean = false;

    @Output() xlsAction = new EventEmitter();

    @Output() csvAction = new EventEmitter();

    disabled() {
      return false;
    }

    xlsClicked(event) {
        this.xlsAction.next(event);
    }

    csvClicked(event) {
        this.csvAction.next(event);
    }

}
